import getSearchParams from 'helpers/get_search_parameters';
import getCookieValue from 'helpers/get_cookie';

const LANDING_PAGES = '/go';
const PARTNERS_INVITE_PAGE = '/partners/invite';
const referralSource =
  getCookieValue('referral_token') || getSearchParams().includes('referral_token');

const pathnameString = window.location.pathname.toString();

export const isLandingPage = () => {
  return pathnameString.includes(LANDING_PAGES);
};

export const isPartnersInvitePage = () => {
  return pathnameString.includes(PARTNERS_INVITE_PAGE);
};

export const isReferrals = () => {
  return referralSource;
};

export const isOrganicPage = () => {
  return !isLandingPage() && !isPartnersInvitePage() && !isReferrals();
};
